<template>
  <ul class="list-group">
    <li class="list-group-item">
      <router-link to="/employees/create">Yangi ishchi qo'shish</router-link>
    </li>
    <li class="list-group-item">
      <router-link to="/employees">Ishchilar ro'yxati</router-link>
    </li>
    <li class="list-group-item">
      <router-link to="/employees/bonuses">Ortiqcha ishlaganlarni kiritish</router-link>
    </li>
    <li class="list-group-item">
      <router-link to="/employees/result">Umumiy natija</router-link>
    </li>
    <li class="list-group-item">
      <router-link to="/employees/data/delete">Noto'g'ri kiritilgan ma'lumotlarni o'chirish</router-link>
    </li>
    <li class="list-group-item">
      <router-link to="/employees/holidayToAll">Bayram kuni uchun hammadan ishlagan kunini kamaytirish</router-link>
    </li>
    <li class="list-group-item">
      <router-link to="/employees/bulkAbsent">Kelmagan kunlarni to'plab kiritish</router-link>
    </li>
  </ul>
</template>

<script>
export default {
  name: "HomeView",
};
</script>